import { showError } from './utils';
import axios from 'axios';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '',
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    showError(error, { silentToast: error?.config?.handleErrorLocally === true });
    return {
      status: error?.response?.status,
      headers: error?.response?.headers,
      config: error?.config,
      data: {
        code: error?.response?.data?.code,
        success: false,
        message: error?.message || 'Network Error',
        data: null
      }
    };
  }
);
